import 'vuetify/styles';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import { aliases, fa } from 'vuetify/iconsets/fa';
import '@fortawesome/fontawesome-free/css/all.css';

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#ff6e00', // '#007bff',
    secondary: '#54433a', // '#2c3e50',
    error: '#c0392b',
    info: '#007bff',
    success: '#28a745',
    warning: '#ffc107',
  },
};

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
        fa,
      },
    },
    theme: {
      defaultTheme: 'myCustomLightTheme',
      themes: {
        myCustomLightTheme,
      },
    },
  });
  app.vueApp.use(vuetify);
});
